
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { TokenInterceptor } from 'app/authorized-http.service';
import { UtilsService } from 'app/services/utils.service';
import { FooterCellResource } from 'app/models/FooterCellResource';
import { Http, Response } from '@angular/http';
import { FooterCellTypeResource } from 'app/models/FooterCellTypeResource';
import { FooterLinksResource } from 'app/models/FooterLinksResource';
import { FooterLinksTypeResource } from 'app/models/FooterLinksTypeResource';
import { FooterLinksListResource } from 'app/models/FooterLinksListResource';
import { FooterCellTypeListResource } from 'app/models/footerCellTypeListResource';
import { FooterLinksTypeListResource } from 'app/models/FooterLinksTypeListResource';
import { HttpClient } from "@angular/common/http";
import { environment } from "app/baseUrl";


@Injectable()
export class EditColumnService {

  constructor(private http: HttpClient, private httpa: TokenInterceptor, private utilsService: UtilsService) { }

  saveCellService(url, body): Observable<FooterCellResource> {
    return this.http.post<FooterCellResource>(environment['url'] + url, body)
  }

  saveLinksResource(url, body): Observable<FooterLinksResource> {
    return this.http.post<FooterLinksResource>(environment['url'] + url, body)
  }


  getFooterCellTypeResource(url): Observable<FooterCellTypeListResource> {
    return this.http.get<FooterCellTypeListResource>(environment['url'] + url)
  }


  getLinkTypes(url): Observable<FooterLinksTypeListResource> {
    return this.http.get<FooterLinksTypeListResource>(environment['url'] + url)
  }

  getLinksByCell(url): Observable<FooterLinksListResource> {
    return this.http.get<FooterLinksListResource>(environment['url'] + url)
  }

  getOne(url): Observable<FooterCellResource> {
    return this.http.get<FooterCellResource>(environment['url'] + url)
  }

  deleteCellLink(url): Observable<FooterLinksResource> {
    return this.http.get<FooterLinksResource>(environment['url'] + url)
  }

  private FooterLinksResource(res: Response) {
    let body = res.json()
    return body || [] // returneaza vector gol
  }

  getAllActiveLinks(url): Observable<FooterLinksListResource> {
    return this.http.get<FooterLinksListResource>(environment['url'] + url)
  }

  shiftElements(url, body): Observable<any> {
    return this.http.post<any>(environment['url'] + url, body)
  }


}
